<!--
* @Description: 说明 全局loading
* @version: 版本 3.4
* @Author: 作者 chuzhangyi
* @Date: 2020-07-06 09:36:19
 * @LastEditTime: 2024-07-17 10:11:33
-->
<template>
  <van-overlay id='LOAD' :show="show" class-name='loadStyle' :style="{'backgroundColor':(showBackColor?backColor:'')}" ref='load'>
    <van-loading :color='color' :type='type' :size='size' :text-size='textSize' :vertical='vertical'>{{msg}}</van-loading>
  </van-overlay>
</template>

<script>
export default {

  //import引入的组件需要注入到对象中才能使用
  components: {},

  //props数据
  props: {},

  //这里存放数据
  data () {
    return {
      show: false, // 是否显示
      color: '#fff', // 颜色
      type: 'circular', // 类型，可选值为 spinner
      size: '40', // 加载图标大小，默认单位为px
      textSize: '14', // 文字大小，默认单位为px
      vertical: true, //	是否垂直排列图标和文字内容
      msg: '加载中...',// 提示文本
      showBackColor: false,// 展示背景色
      backColor:'rgba(0,0,0,.5)',// 背景色
    };
  },

  //监听属性 类似于data概念
  computed: {},

  //生命周期 - 创建完成（可以访问当前this实例）
  created () {

  },

  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // log(this._data)
  },

  //方法集合
  methods: {

  },

  //监控data中的数据变化
  watch: {},

  //生命周期 - 销毁之前
  beforeDestroy () { },

  //生命周期 - 销毁完成
  destroyed () { },
}
</script>
<style lang='less' scoped>
.loadStyle {
  background-color: rgba(0, 0, 0, 0);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 40%;
  color: #fff;
  z-index: 99;
  .van-loading {
    padding: 15px 20px;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 5px;
    .van-loading__text {
      color: #fff;
    }
  }
}
</style>
